// Standard <main> landmark wrapper for top-level page components.
//
// Each public route should render exactly one of these so screen
// readers can jump to it via the SkipLink (which targets
// ``#main-content``) and landmark navigation. ``tabIndex={-1}`` lets
// us programmatically focus the region without making it part of the
// visible tab order.
//
// On mount (i.e. on every route change, since each route renders a
// fresh <Page>) we move keyboard focus here. SR / keyboard / low-
// vision users hear the new page's landing point instead of staying
// parked on whichever link they just activated. ``preventScroll``
// keeps the existing scroll position intact (useful for in-page
// anchor jumps on the same route).
//
//   import Page from "../../a11y/Page";
//
//   return (
//     <>
//       <Navigation ... />
//       <Page>
//         ...page content...
//       </Page>
//     </>
//   );

import { useEffect, useRef } from "react";
import { useT } from "../i18n/I18nContext";

export default function Page({ children, className = "" }) {
  const t = useT();
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    try {
      el.focus({ preventScroll: true });
    } catch {
      el.focus();
    }
  }, []);

  return (
    <main
      id="main-content"
      tabIndex={-1}
      aria-label={t("a11y.main_landmark")}
      ref={ref}
      className={className}
    >
      {children}
    </main>
  );
}
